
import { computed, defineComponent, PropType, ref, watch } from "vue";
import EditCommandSerif from "@/components/EditCommandSerif.vue";
import EditCommandOnomatope from "@/components/EditCommandOnomatope.vue";
import EditCommandBalloon from "@/components/EditCommandBalloon.vue";
import EditCommandUserImages from "@/components/EditCommandUserImages.vue";
import { EditStore } from "@/stores";

enum CommandTabs {
  Serif,
  Onomatope,
  Balloon,
  UserImage,
}

export default defineComponent({
  name: "EditCommand",
  components: {
    EditCommandSerif,
    EditCommandOnomatope,
    EditCommandBalloon,
    EditCommandUserImages,
  },
  props: {
    editStore: { type: Object as PropType<EditStore> },
  },
  setup(props) {
    const selectedTab = ref(CommandTabs.Serif);
    const serif = CommandTabs.Serif;
    const onomatope = CommandTabs.Onomatope;
    const balloon = CommandTabs.Balloon;
    const userImage = CommandTabs.UserImage;
    const isFamous = computed(
      () => props.editStore?.state.selectedFrame?.author.isFamous ?? false
    );

    return {
      selectedTab,
      serif,
      onomatope,
      balloon,
      userImage,
      isFamous,
    };
  },
});
